import { render, staticRenderFns } from "./ContactDataManagement.vue?vue&type=template&id=a6fa006c&"
import script from "./ContactDataManagement.vue?vue&type=script&lang=js&"
export * from "./ContactDataManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports